// apps/web/src/components/landing-v2/proofs/DeckMonthProof.tsx
import { Link } from 'react-router-dom'

/** Theme 04 / Deck of the month — featured "Breath of Gold" tile.
 *  Two-column on wide viewports (cover + meta); stacks below ~520px.
 *  Reference: handoff .mm-deckmonth. */
export function DeckMonthProof() {
  return (
    <div
      className="absolute inset-0 grid gap-4 p-5"
      style={{
        background:
          'radial-gradient(ellipse at 30% 0%, color-mix(in oklab, var(--color-candle-orange) 12%, transparent), transparent 60%)',
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.2fr)',
      }}
    >
      {/* Cover */}
      <div
        className="relative flex min-h-0 flex-col overflow-hidden rounded-lg border p-3.5"
        style={{
          background:
            'radial-gradient(ellipse at 50% 20%, color-mix(in oklab, var(--color-gold-light-legacy) 55%, transparent), transparent 60%), radial-gradient(ellipse at 50% 80%, color-mix(in oklab, var(--color-rose) 30%, transparent), transparent 60%), linear-gradient(180deg, #3a2410 0%, #1a0d0d 100%)' /* theme-audit: unmapped #3a2410 / #1a0d0d deep-amber cover gradient stops lack dedicated tokens */,
          borderColor: 'color-mix(in oklab, var(--color-gold-light-legacy) 30%, transparent)',
          boxShadow:
            '0 18px 36px -12px rgba(0,0,0,0.7), inset 0 0 0 1px var(--hairline-faint)' /* theme-audit: bespoke shadow */,
          color: 'var(--color-gold-light-legacy)',
        }}
      >
        <span
          className="absolute right-3 top-3 font-display"
          style={{
            color: 'color-mix(in oklab, var(--color-gold-light-legacy) 60%, transparent)',
            fontSize: '0.72rem',
            letterSpacing: '0.06em',
          }}
        >
          № 02
        </span>
        <div
          className="text-[9px] uppercase"
          style={{ color: 'rgba(255,255,255,0.55)' /* theme-audit: out-of-band white text α=0.55, not a hairline */, letterSpacing: '0.3em' }}
        >
          Breath of
        </div>
        <div
          className="my-auto font-display italic"
          style={{
            color: '#fff2d6' /* theme-audit: unmapped #fff2d6 cream highlight lacks dedicated token */,
            fontSize: '1.45rem',
            lineHeight: 1,
            letterSpacing: '-0.01em',
            textShadow: '0 2px 12px rgba(0,0,0,0.6)' /* theme-audit: bespoke shadow */,
          }}
        >
          Breath
          <br />
          of <em className="italic">Gold</em>
        </div>
        <div
          className="my-1 text-center font-display"
          style={{
            color: 'color-mix(in oklab, var(--color-gold-light-legacy) 70%, transparent)',
            fontSize: '1.8rem',
          }}
        >
          ✦
        </div>
        <div
          className="text-center text-[9px] uppercase"
          style={{ color: 'rgba(255,255,255,0.4)' /* theme-audit: out-of-band white text α=0.4, not a hairline */, letterSpacing: '0.22em' }}
        >
          A deck for the body
        </div>
      </div>

      {/* Meta */}
      <div className="flex min-w-0 flex-col gap-1.5">
        <span
          className="w-fit rounded-pill border border-gold-light-legacy/30 px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.22em] text-gold-light-legacy"
          style={{ background: 'color-mix(in oklab, var(--color-gold-light-legacy) 10%, transparent)' }}
        >
          Featured deck
        </span>
        <div
          className="font-display text-text-primary"
          style={{ fontSize: '1.1rem', lineHeight: 1.15 }}
        >
          <em className="italic">Breath of Gold</em> — a breathwork deck.
        </div>
        <div className="text-[12px] text-text-secondary">
          A 67-card breathwork-paired oracle deck by Adrienne Rivera, TEDx
          speaker and founder of Breath of Gold®.{' '}
          <Link
            to="/practitioners/adrienne"
            className="text-gold-light-legacy"
            style={{ borderBottom: '1px solid currentColor' }}
          >
            Adrienne ↗
          </Link>
        </div>
        <div
          className="mt-auto flex items-center gap-2 text-[10px] uppercase text-text-muted"
          style={{ letterSpacing: '0.16em' }}
        >
          <span>67 cards</span>
          <span
            className="inline-block h-1 w-1 rounded-full"
            style={{ background: 'var(--color-text-muted)' }}
          />
          <span>Cosmic-included</span>
          <span
            className="inline-block h-1 w-1 rounded-full"
            style={{ background: 'var(--color-text-muted)' }}
          />
          <span>In the library</span>
        </div>
      </div>
    </div>
  )
}
